import { useCallback, useEffect, useState } from 'react';
import { MapPin, Pencil } from 'lucide-react';
import { adressenAPI } from '@/lib/api';
import AdresseFormular from '@/components/adressen/AdresseFormular';

/* Adresse am Mitglied (23.10.2026): zeigt die Adresse, wie Rechnung und Vertrag sie lesen, und lässt sie ändern.
   Eine Änderung geht an den Lead und an seine laufenden Verträge; das unterschriebene PDF bleibt, der Nachweis vermerkt sie. */
const zeile = (a) => [a?.strasse, [a?.plz, a?.ort].filter(Boolean).join(' ')].filter(Boolean).join(', ');

export default function AdresseKarte({ leadId, darf = false, eingebettet = false }) {
  const [stand, setStand] = useState(null);
  const [offen, setOffen] = useState(false);
  const lade = useCallback(() => {
    adressenAPI.lesen(leadId).then((r) => setStand(r.data)).catch(() => setStand(null));
  }, [leadId]);
  useEffect(() => { setOffen(false); lade(); }, [lade]);
  if (!stand) return null;
  const w = stand.wirksam || {};
  const voll = w.strasse && w.plz && w.ort;
  const alt = !voll && (stand.alt?.address || stand.alt?.city) ? [stand.alt.address, stand.alt.city].filter(Boolean).join(', ') : '';
  const start = voll ? w : { strasse: w.strasse || stand.alt?.address || '', plz: w.plz, ort: w.ort || stand.alt?.city || '' };
  const inhalt = (
    <div className="space-y-2 text-sm" data-testid="adresse-karte">
      <div className="flex items-start gap-2">
        <MapPin className="w-4 h-4 mt-0.5 text-muted-foreground shrink-0" />
        <div className="flex-1 min-w-0">
          {voll ? <span>{zeile(w)}</span> : <span className="text-amber-700 dark:text-amber-400">Adresse fehlt{zeile(w) ? ` (nur: ${zeile(w)})` : ''}</span>}
          {alt && <span className="block text-xs text-muted-foreground">Altangabe am Lead: {alt}</span>}
          {stand.vertraege?.length > 0 && <span className="block text-xs text-muted-foreground">gilt auch für {stand.vertraege.map((v) => v.vertragsnummer || 'Vertrag').join(', ')}</span>}
        </div>
        {darf && !offen && (
          <button type="button" onClick={() => setOffen(true)} className="inline-flex items-center gap-1 text-xs text-marke hover:underline" data-testid="adresse-bearbeiten">
            <Pencil className="w-3 h-3" /> {voll ? 'ändern' : 'nachtragen'}
          </button>
        )}
      </div>
      {offen && <AdresseFormular leadId={leadId} start={start} onAbbrechen={() => setOffen(false)} onGespeichert={() => { setOffen(false); lade(); }} />}
    </div>
  );
  if (eingebettet) return inhalt;
  return (
    <div className="rounded-xl border border-border/60 bg-card p-4">
      <p className="text-sm font-semibold mb-2">Adresse</p>
      {inhalt}
    </div>
  );
}
